import { CircleMarker, MapContainer, TileLayer, useMapEvents } from 'react-leaflet'

type Props = {lat?:number;lng?:number;onChange:(lat:number,lng:number)=>void}
function Clicker({onChange}:{onChange:(lat:number,lng:number)=>void}) {
  useMapEvents({click(e){onChange(e.latlng.lat,e.latlng.lng)}})
  return null
}
export default function LocationPicker({lat,lng,onChange}:Props) {
  return <div>
    <p className="hint">Поставьте приблизительную точку в районе склада. Точный адрес можно скрыть.</p>
    <MapContainer className="location-picker" center={[lat ?? 55.75,lng ?? 37.62]} zoom={lat ? 11 : 4}>
      <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Clicker onChange={onChange}/>
      {lat !== undefined && lng !== undefined && <CircleMarker center={[lat,lng]} radius={10}/>} 
    </MapContainer>
  </div>
}
